import { useState, useEffect } from 'react';
import { WAITLIST_LOCAL_STORAGE_KEY } from 'lib/product-actions';

const readWaitlistText = (): string => {
  try {
    const submitted =
      typeof window !== 'undefined' &&
      !!JSON.parse(localStorage.getItem('digioh_json') || '{}')?.[
        WAITLIST_LOCAL_STORAGE_KEY
      ];
    return submitted ? 'Waitlist Joined' : 'Join the Waitlist';
  } catch {
    return 'Join the Waitlist';
  }
};

export const useWaitlistButtonText = (enabled: boolean): string => {
  const [text, setText] = useState(readWaitlistText);

  useEffect(() => {
    if (!enabled || typeof window === 'undefined' || !window.localStorage) return;
    const id = setInterval(() => {
      setText((prev) => {
        const updated = readWaitlistText();
        return updated !== prev ? updated : prev;
      });
    }, 300);
    return () => clearInterval(id);
  }, [enabled]);

  return text;
};
